import axios from 'axios'

let _axios = axios.create({
})

// Add a response interceptor
_axios.interceptors.response.use(response => {
  return response
}, error => {
  // Do something with response error
  if (error.response && error.response.data) {
    console.log(JSON.stringify(error.config))
    console.log(JSON.stringify(error.response.data))
  }
  return Promise.reject(error.response)
})

export default _axios
